export default __webpack_public_path__ + "6728a9cdb8f013e7d343bcfaf2e158c7.svg";